export default __webpack_public_path__ + "static/media/bar.ec97df01.jpg";